import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { BaseDataService } from './base-data-service';
import { DashboardKPIRequest, DashboardKPIResponse } from './def/dashboard-KPI';

import { dashboardKPIModel } from 'libs/models/classes/dashboard-KPI.model';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs/internal/observable/throwError';
import { GlobalVariablesService } from './global-variables.service';

@Injectable()
export class DashboardKpiService extends BaseDataService {
  KpiData: any;
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    protected globalVariables: GlobalVariablesService
  ) {
    super(http, configService, globalVariables);
  }

  getDashboardKPIData(
    payload: DashboardKPIRequest
  ): Observable<dashboardKPIModel> {
    const url = `${this.serviceBaseUrl}/infinity/get-broker-view-metrics`;
    return this.post<DashboardKPIResponse>(url, { body: payload }).pipe(
      map(data => {
        this.KpiData = data;
        return this.KpiData;
      }),
      catchError(this.handleError)
    );
  }

  private handleError(err) {
    return throwError(err);
  }
}
